"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.motionEaseInEaseOut = exports.motionDurationSlowest = exports.motionDurationSlower = exports.motionDurationSlow = exports.motionDurationNormal = exports.motionDurationFast = void 0;
const motionDurationFast = exports.motionDurationFast = '100ms';
const motionDurationNormal = exports.motionDurationNormal = '200ms';
const motionDurationSlow = exports.motionDurationSlow = '300ms';
const motionDurationSlower = exports.motionDurationSlower = '500ms';
const motionDurationSlowest = exports.motionDurationSlowest = '1000ms';
const motionEaseInEaseOut = exports.motionEaseInEaseOut = 'ease-in-out';